module.exports = __webpack_public_path__ + "static/img/1.06682c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/1.png
// module id = XuzT
// module chunks = 0